import { time_interval } from "./index.js";
import { date } from "./index.js";
import { date_and_time } from "./index.js";
import { local_time } from "./index.js";
import { event_occurrence } from "./index.js";
import { time_measure_with_unit } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class time_interval_with_bounds extends time_interval {
    get type() {
        return EntityTypesAP214.TIME_INTERVAL_WITH_BOUNDS;
    }
    get primary_bound() {
        if (this.primary_bound_ === void 0) {
            const value = this.extractReference(3, true);
            if (!(value instanceof date) && !(value instanceof date_and_time) && !(value instanceof local_time) && !(value instanceof event_occurrence) && value !== null) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.primary_bound_ = value;
        }
        return this.primary_bound_;
    }
    get secondary_bound() {
        if (this.secondary_bound_ === void 0) {
            const value = this.extractReference(4, true);
            if (!(value instanceof date) && !(value instanceof date_and_time) && !(value instanceof local_time) && !(value instanceof event_occurrence) && value !== null) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.secondary_bound_ = value;
        }
        return this.secondary_bound_;
    }
    get duration() {
        if (this.duration_ === void 0) {
            this.duration_ = this.extractElement(5, true, time_measure_with_unit);
        }
        return this.duration_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
time_interval_with_bounds.query = [EntityTypesAP214.TIME_INTERVAL_WITH_BOUNDS];
time_interval_with_bounds.expectedType = EntityTypesAP214.TIME_INTERVAL_WITH_BOUNDS;
